module.exports = "/packs/practical_exam_complete_ribbon-82c4e2655488735066c84cfb680621f3.svg";